export default __webpack_public_path__ + "static/media/about3.f88f4e23.jpg";